import axios from 'axios'

export const axiosInstance = axios.create({
  baseURL:
    process.env.REACT_APP_ENVIRONMENT === 'production'
      ? 'https://api.zoidcore.com'
      : 'https://qz1k6rmf1g.execute-api.eu-central-1.amazonaws.com',
})

axiosInstance.interceptors.request.use(
  async function (config) {
    const storedAuthStateJson =
      sessionStorage.getItem('authState') || localStorage.getItem('authState')

    const storedAuthState = storedAuthStateJson ? JSON.parse(storedAuthStateJson) : null

    if (
      config.url === '/core/public/login' ||
      config.url === '/public/refreshSession' ||
      config.url === '/core/public/register'
    ) {
      return config
    }

    const token = storedAuthState?.user?.accessToken
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  },
)

axiosInstance.interceptors.response.use(
  (res) => {
    return res
  },
  async (err) => {
    const originalRequest = err.config
    const whitelistCalls = ['/core/public/login', '/core/public/loginWithGoogle']

    if (
      err.response?.status === 401 &&
      !originalRequest._retry &&
      !whitelistCalls.includes(originalRequest.url)
    ) {
      originalRequest._retry = true

      const storedAuthStateJson =
        sessionStorage.getItem('authState') || localStorage.getItem('authState')
      const storedAuthState = storedAuthStateJson ? JSON.parse(storedAuthStateJson) : null
      const rememberMe = storedAuthState?.user?.rememberMe || false
      const refreshToken = storedAuthState?.user?.refreshToken || ''

      if (refreshToken) {
        const response = await axiosInstance.post('/public/refreshSession', {
          refreshToken,
        })

        const newToken = response?.data?.data?.token
        if (newToken) {
          storedAuthState.user.accessToken = newToken
          rememberMe
            ? localStorage.setItem('authState', JSON.stringify(storedAuthState))
            : sessionStorage.setItem('authState', JSON.stringify(storedAuthState))

          axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + newToken
          originalRequest.headers['Authorization'] = 'Bearer ' + newToken
          return axiosInstance(originalRequest)
        }
      }
    }
    return Promise.reject(err)
  },
)
